export default __webpack_public_path__ + "static/media/literspopup.75b9d5ca.png";